<span class="checkbox-wrap">
  <span class="ant-checkbox" [class.ant-checkbox-checked]="nzChecked && !nzIndeterminate" [class.ant-checkbox-disabled]="nzDisabled" [class.ant-checkbox-indeterminate]="nzIndeterminate">
    <input
      class="ant-checkbox-input"
      #inputElement
      [attr.autofocus]="nzAutoFocus ? 'autofocus' : null"
      [attr.id]="nzId"
      [attr.aria-checked]="nzIndeterminate ? 'mixed' : nzChecked"
      [attr.aria-label]="a11yLabel"
      [attr.aria-labelledby]="a11yLabelledby"
      [checked]="nzChecked"
      [ngModel]="nzChecked"
      [disabled]="nzDisabled"
      (ngModelChange)="innerCheckedChange($event)"
      (click)="onClick($event)"
      type="checkbox" />
    <span class="ant-checkbox-inner"></span>
  </span>
  <span #checkboxLabel [class.label-content-ellipsis]="uiEllipsis"><ng-content></ng-content></span>
</span>

<span class="checkbox-error-message" *ngIf="uiStatusError && uiErrorMessage" (click)="$event.stopPropagation(); $event.preventDefault()"><i ui-icon uiType="caution"></i>{{ uiErrorMessage }}</span>
